export const canUseDashboard = (user) => {
  const role = String(user?.role || '').toLowerCase();
  return role === 'admin' || role === 'manager';
};
